import { createBuiltInComponentMeta, withComponentMeta } from '../../internal/component-meta';
import { GridItem as GridItemComponent } from './GridItem';
export const GridItem = withComponentMeta(GridItemComponent, createBuiltInComponentMeta('GridItem'));
//# sourceMappingURL=index.js.map